import React, { useState, useEffect, useCallback } from 'react';
import update from 'immutability-helper';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import './Products.scss';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import HeaderProduto from '../../../Components/Header-Produto/Header-Produto';
import ModalPendencias from '../../../Components/Modal-Pendencias/Modal-Pendencias';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';

const ProductCileDetails = (props) => {
    const config = new Configurations();
    const idProduto = props.match.params.idProduto;
    const novoProduto = idProduto === "novo-produto";

    const [produto, setProduto] = useState({
        nome: '', descricao: '', idTipoProduto: 4, imagem: '', idioma: 'Português', peso: '', autor: '', dtlancamento: null, isbn: null, ativo: true, fatorPeriodo: 2,
    });
    const [isLoadingProduto, setIsLoadingProduto] = useState(true);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [isLoadingAlteracoes, setIsLoadingAlteracoes] = useState(false);
    const [modalSucessoAlteracao, setModalSucessoAlteracao] = useState(false);
    const [modalPendencia, setModalPendencia] = useState(false);
    const [pendencias, setPendencias] = useState([]);
    const [habilitaSalvar, setHabilitaSalvar] = useState(false);
    const [nomeProduto, setNomeProduto] = useState('');
    const [imagem, setImagem] = useState('');
    const [imagemAlt, setImagemAlt] = useState('');
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [focused, setFocused] = useState(false);
    const [versaoAtual, setVersaoAtual] = useState(null);


    useEffect(() => {
        setIsLoadingProduto(true);
        if (!novoProduto) {
            axios.get(config.apiBasePath + `/v2/produtos/${idProduto}`)
                .then(response => {
                    carregaInfosProduto(response.data.produto);
                })
                .catch(err => console.log(err));
        } else {
            setInitialState();
        }
    }, [idProduto, novoProduto, config.apiBasePath]);

    const setInitialState = () => {
        setProduto({
            nome: '', sku: '', descricao: '', idTipoProduto: 4, imagem: '', idioma: 'Português', peso: '', autor: '', dtlancamento: null, isbn: '', ativo: true, urlCompra: '',
        });
        setIsLoadingProduto(false);
        setIsLoadingStatus(false);
        setIsLoadingAlteracoes(false);
        setModalSucessoAlteracao(false);
        setModalPendencia(false);
        setPendencias([]);
        setImagemAlt('');
        setImagem('');
        setMetaTitle('');
        setMetaDescription('');
        setNomeProduto('');
        setVersaoAtual(null);
    }

    const carregaInfosProduto = (_produto) => {
        const dtlancamento = _produto.dtlancamento ? moment(_produto.dtlancamento) : null;
        setProduto({ ..._produto, dtlancamento });
        setNomeProduto(_produto.nome);
        setModalSucessoAlteracao(false);
        setImagemAlt(_produto.imagemAlt || '');
        setImagem(_produto.imagem || '');
        setMetaTitle(_produto.metaTitle || '');
        setMetaDescription(_produto.metaDescription || '');
        setVersaoAtual(_produto);
        setIsLoadingProduto(false);
        validaPeriodos(_produto.idTipoProduto, true);
    }


    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setProduto((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleRadio = (e) => {
        const _name = e.target.name;
        let _value = e.target.value;

        if (["idTipoProduto", "idOrigem", "fatorPeriodo", "idPeriodicidade"].includes(_name)) {
            _value = Number(_value);
        }
        setProduto(prev => update(prev, { [_name]: { $set: _value } }));
        if (_name === "idTipoProduto") validaPeriodos(_value);
    }

    const onDateChange = useCallback((date) => {
        setProduto(prev => ({
            ...prev,
            dtlancamento: date && moment.isMoment(date) ? date : (date ? moment(date) : null)
        }));
    }, []);

    const _outsideRange = () => false;

    const handleOnChange = (e) => {
        const _name = e.target.name, _value = e.target.value;
        if (_name === 'imagemAlt') setImagemAlt(_value);
        if (_name === 'metaTitle') setMetaTitle(_value);
        if (_name === 'metaDescription') setMetaDescription(_value);
        if (_name === 'imagem') setImagem(_value);
    }

    const closeErrorModal = () => {
        setHasError(false);
        setErrorMessage("");
    }


    const toggleModalPendencia = () => {
        setModalPendencia(prev => !prev);
    }

    const toggleSucessoAlteracao = () => {
        setModalSucessoAlteracao(prev => {
            if (prev) {
                window.history.go(-1);
                return false;
            }
            return true;
        });
    }

    const validaPeriodos = (idTipoProduto, skipSetProduto) => {
        const tipo = parseInt(idTipoProduto, 10);
        if (tipo === 4) {
            if (!skipSetProduto) setProduto(prev => update(prev, { fatorPeriodo: { $set: 1 }, idPeriodicidade: { $set: 3 } }));
        } else {
            if (!skipSetProduto) setProduto(prev => update(prev, { fatorPeriodo: { $set: 2 } }));
        }
    }

    const mudaStatusProduto = (_metodo) => {
        setIsLoadingStatus(true);
        axios.put(config.apiBasePath + `/v2/produtos/${idProduto}/${_metodo}`)
            .then(() => { toggleSucessoAlteracao(); })
            .catch(err => { console.log(err); })
            .finally(() => { setIsLoadingStatus(false); });
    }

    const handleError = (err) => {
        setHasError(true);
        setErrorMessage(err.response ? err.response.data.error.message : 'Erro inesperado.');
    }

    const habilitaSalvarFn = () => {
        const _nomeValido = (produto.nome || '').trim() !== '';
        const _skuValido = (produto.sku || '').toString().trim() !== '';
        const _pesoValido = (produto.peso || '').toString().trim() !== '';
        const _infosObrigatorias = [
            { campo: "Nome do Produto", valido: _nomeValido },
            { campo: "SKU", valido: _skuValido },
            { campo: "Peso", valido: _pesoValido },
        ];
        const _pendencias = _infosObrigatorias.filter(item => !item.valido);

        if (_pendencias.length === 0) {
            setHabilitaSalvar(true);
        } else {
            setPendencias(_pendencias);
            toggleModalPendencia();
        }
    }

    useEffect(() => {
        if (habilitaSalvar) {
            salvarAlteracoes([]);
        }
    }, [habilitaSalvar]);

    const salvarAlteracoes = (_pend) => {
        let pesoNormalizado = produto.peso;
        if (typeof pesoNormalizado === 'string') {
            pesoNormalizado = pesoNormalizado.replace(',', '.');
        }
        pesoNormalizado = Number(pesoNormalizado);
        const bodyPut = {
            nome: produto.nome,
            descricao: produto.descricao,
            urlCompra: produto.urlCompra,
            idTipoProduto: produto.idTipoProduto,
            peso: pesoNormalizado,
            idioma: produto.idioma,
            autor: produto.autor,
            dtlancamento: moment(produto.dtlancamento).format("YYYY-MM-DD"),
            isbn: produto.isbn,
            imagem: imagem,
            imagemAlt: imagemAlt,
            metaTitle: metaTitle,
            metaDescription: metaDescription,
            sku: produto.sku,
        };
        const bodyPost = {
            nome: produto.nome,
            descricao: produto.descricao,
            urlCompra: produto.urlCompra,
            idTipoProduto: produto.idTipoProduto,
            peso: pesoNormalizado,
            idioma: produto.idioma,
            autor: produto.autor,
            dtlancamento: moment(produto.dtlancamento).format("YYYY-MM-DD"),
            isbn: produto.isbn,
            imagem: imagem,
            imagemAlt: imagemAlt,
            metaTitle: metaTitle,
            metaDescription: metaDescription,
            sku: produto.sku,
            ativo: produto.ativo,
        };
        if (habilitaSalvar) {
            setIsLoadingAlteracoes(true);
            const _infosProdutoState = {
                ...produto,
            };
            setProduto(_infosProdutoState);
            if (novoProduto) {
                axios.post(config.apiBasePath + `/v2/produtos/novo-produto`, bodyPost)
                    .then(() => { toggleSucessoAlteracao(); })
                    .catch(handleError)
                    .finally(() => { setIsLoadingAlteracoes(false); });
            } else {
                axios.put(config.apiBasePath + `/v2/produtos/${idProduto}`, bodyPut)
                    .then(() => { toggleSucessoAlteracao(); })
                    .catch(handleError)
                    .finally(() => { setIsLoadingAlteracoes(false); });
            }
        } else {
            setPendencias(_pend);
            toggleModalPendencia();
        }
    }

    return (
        <div className="row product-details mb-3">
            {!isLoadingProduto && (
                <HeaderProduto
                    salvarAlteracoes={habilitaSalvarFn}
                    produto={produto}
                    mudaStatusProduto={mudaStatusProduto}
                    novoProduto={novoProduto}
                    versaoAtual={versaoAtual}
                    isLoadingAlteracoes={isLoadingAlteracoes}
                    isLoadingStatus={isLoadingStatus}
                />
            )}
            <div className="div-produto mb-3">
                <div className="col-12">
                    {isLoadingProduto ? (
                        <div className="row">
                            <div className="col-12 py-3 text-center">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-12">
                                <div className="row no-gutters align-items-center">
                                    <div className="col-12">
                                        {novoProduto ? (
                                            <h2 className="title-1">Cadastro de Novo Produto</h2>
                                        ) : (
                                            <h2 className="title-1">Detalhes do Produto - {nomeProduto}</h2>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-lg-12'>
                                <div className='row'>
                                    <div className="col-12 col-lg-4 py-3">
                                        <label>Nome do Produto<sup><small>(*)</small></sup></label>
                                        <input name="nome" type="text" className="form-control" onChange={onChangeInput} value={produto.nome} autoComplete="off" />
                                    </div>
                                    <div className="col-12 col-lg-2 py-3">
                                        <label>SKU<sup><small>(*)</small></sup></label>
                                        <input name="sku" type="text" className="form-control" onChange={onChangeInput} value={produto.sku} autoComplete="off" />
                                    </div>
                                    <div className="col-12 col-lg-2 py-3">
                                        <label className="d-block">Dt. Lançamento</label>
                                        <SingleDatePicker
                                            date={produto.dtlancamento && moment.isMoment(produto.dtlancamento) ? produto.dtlancamento : null}
                                            onDateChange={onDateChange}
                                            focused={focused}
                                            onFocusChange={({ focused }) => setFocused(focused)}
                                            id="dtlancamento"
                                            verticalHeight={450}
                                            numberOfMonths={1}
                                            small={true}
                                            isOutsideRange={_outsideRange}
                                            placeholder=""
                                            block={true}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-4 py-3">
                                        <label>Autor</label>
                                        <input name="autor" type="text" className="form-control" onChange={onChangeInput} value={produto.autor} autoComplete="off" />
                                    </div>
                                    <div className="col-12">
                                        <label>Descrição</label>
                                        <textarea id="descr" type="text" className="form-control" name="descricao" value={produto.descricao} onChange={onChangeInput} />
                                    </div>
                                    <div className="col-12 col-lg-6 py-3">
                                        <label>Url para compra</label>
                                        <input name="urlCompra" type="text" className="form-control" onChange={onChangeInput} value={produto.urlCompra} autoComplete="off" />
                                    </div>
                                    <div className="col-12 col-lg-3 py-3">
                                        <label>Peso <small>(kg)</small><sup><small>(*)</small></sup> <small className='pl-4 fs-6'>Ex: 620g = 0.62</small></label>
                                        <input name="peso" type="number" className="form-control" onChange={onChangeInput} value={produto.peso} autoComplete="off" />
                                    </div>
                                    <div className="col-12 col-lg-3 py-3">
                                        <label>ISBN</label>
                                        <input name="isbn" type="text" className="form-control" onChange={onChangeInput} value={produto.isbn} autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                            {/* <div className='col-12 col-lg-2 py-3'>
                                <ImagemFukyo
                                    className={`img-imagem-artigo img img-fluid`}
                                    src={'https://assets.betalabs.net/production/editorabrasilseikyo/item-images/761c24d2e8412f326d37495670091ea7.jpg'}
                                    alt={"imagem do artigo"}
                                />
                            </div> */}
                            <div className="col-12 col-lg-6">
                                <label>Nome da imagem <small>(Incluir extensão. Ex: escolha-a-vida.jpg)</small></label>
                                <input name="imagem" type="text" className="form-control" onChange={handleOnChange} value={imagem} autoComplete="off" />
                            </div>
                            <div className="col-12 col-lg-6">
                                <label>Imagem alt</label>
                                <input name="imagemAlt" type="text" className="form-control" onChange={handleOnChange} value={imagemAlt} autoComplete="off" />
                            </div>

                            <div className="col-12 col-lg-6 mt-3">
                                <label>Meta title</label>
                                <input name="metaTitle" type="text" className="form-control" onChange={handleOnChange} value={metaTitle} autoComplete="off" />
                            </div>
                            <div className="col-12 col-lg-6 mt-3">
                                <label>Meta description</label>
                                <input name="metaDescription" type="text" className="form-control" onChange={handleOnChange} value={metaDescription} autoComplete="off" />
                            </div>
                            <div className="col-12 col-lg-2 py-3">
                                <label>Tipo do Produto</label>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="idTipoProduto" id="livro" checked={parseInt(produto.idTipoProduto, 10) === 4} value={4} onChange={handleRadio} />
                                    <label className="form-check-label" htmlFor="livro">Livro</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="idTipoProduto" id="acessorio" checked={parseInt(produto.idTipoProduto, 10) === 7} value={7} onChange={handleRadio} />
                                    <label className="form-check-label" htmlFor="acessorio">Acessórios / Brindes / Outros</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="idTipoProduto" id="kit" checked={parseInt(produto.idTipoProduto, 10) === 11} value={11} onChange={handleRadio} />
                                    <label className="form-check-label" htmlFor="kit">KIT Pronto</label>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Modal isOpen={modalSucessoAlteracao} toggle={toggleSucessoAlteracao}>
                <ModalHeader toggle={toggleSucessoAlteracao}>
                    {novoProduto ? 'Novo Produto' : 'Edição de Produto'}
                </ModalHeader>
                <ModalBody>
                    {novoProduto ? 'Novo produto criado com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={toggleSucessoAlteracao}>ok</Button>
                </ModalFooter>
            </Modal>
            <ErrorModal
                isOpen={hasError}
                message={errorMessage}
                closeErrorModal={closeErrorModal}
            />
            <ModalPendencias
                isOpen={modalPendencia}
                toggle={toggleModalPendencia}
                pendencias={pendencias}
            />
        </div >
    );
};

export default ProductCileDetails;